import type { Maybe } from '@adornis/base/utilTypes.js';
import type { UserWithPermissionFields } from '../UserWithPermissionFields.js';

export function isSelf(
  currentUser: Maybe<UserWithPermissionFields>,
  viewedUser: Maybe<UserWithPermissionFields>,
): boolean {
  if (!currentUser || !viewedUser) return false;
  return currentUser._id === viewedUser._id;
}
